import { HorizontalLine } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { IProductPageResponse } from "@faire/web-api--source/indigofair/data/IProductPageResponse";
import React from "react";
import styled from "styled-components";

import {
  Breadcrumb,
  IBreadcrumbOption,
} from "@faire/retailer/components/Breadcrumb";

export const ProductBreadcrumbs = ({
  product,
  breadcrumbOptions,
}: {
  product: IProductPageResponse.IPdpProduct;
  breadcrumbOptions: IBreadcrumbOption[];
}) => {
  const options = breadcrumbOptions.slice();
  if (product?.name) {
    options.push({
      label: product.name.translated ?? product.name.original ?? "",
    });
  }

  return (
    <TabletAndAbove>
      <Breadcrumb options={options} horizontalPadding="0" />
      <HorizontalLine />
      <Spacer height="5x" />
    </TabletAndAbove>
  );
};

const TabletAndAbove = styled.div`
  ${responsiveMediaQueries.mobile} {
    display: none;
  }
`;
